export const OFFLINE_SEND_MESSAGE = '장치가 오프라인입니다. 연결이 끊긴 상태라 실제로 동작하지 않을 수 있습니다. 그래도 보낼까요?';
export const OFFLINE_SAVE_MESSAGE = '장치가 오프라인입니다. 연결이 끊긴 상태라 실제로 동작하지 않을 수 있습니다. 그래도 저장할까요?';

// 센서가 오프라인이면 서버가 400 IOT_SENSOR_OFFLINE 으로 막는다.
// 사용자에게 물어보고 확인하면 force=true 로 한 번 더 보낸다.
// 취소하면 silent 표식 에러를 던진다 (onError 에서 토스트 없이 끝내고, 낙관적 갱신은 되돌리게)
export const sendWithOfflineConfirm = async (send, confirmMessage) => {
  try {
    return await send(false);
  } catch (error) {
    if (error?.response?.data?.errorCode !== 'IOT_SENSOR_OFFLINE') throw error;
    if (!window.confirm(confirmMessage)) {
      const cancelled = new Error('IOT_OFFLINE_CANCELLED');
      cancelled.silent = true;
      throw cancelled;
    }
    return send(true);
  }
};
